import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
 
@Component({
  selector: 'app-cstm-notification-bar',
  templateUrl: './cstm-notification-bar.component.html',
  styleUrls: ['./cstm-notification-bar.component.scss']
})
export class CstmNotificationBarComponent {
  dlg_data = {
    title : '',
    body : ''
  }
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,  private _snackRef: MatSnackBarRef<CstmNotificationBarComponent>,) { 
    this.dlg_data = data;
  }

  clsDlgBx(){
    this._snackRef.dismiss();
  }

}
